import React, { Fragment } from "react";
import Icon from "../Icon";

const Error = ({ message }) => (
  <div className="l-wrap--narrow">
    <p className="f-h3 u-mt12 u-mb12 u-center">
      {message && (
        <Fragment>
          {message}
          <br />
        </Fragment>
      )}
      Our system has encountered an error, please try later or call{" "}
      <a href="tel:18663167263">1-866-316-7263</a>
    </p>
  </div>
);

export default Error;
